export default "__VITE_ASSET__BquZrV66__"